// src/components/TeamCard.js
import { Link } from 'react-router-dom';
import { FiUsers } from 'react-icons/fi';

// Add this CSS to your stylesheet
const styles = `
  .team-card {
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 0.5rem;
    transition: box-shadow 0.3s ease;
    margin-bottom: 1rem;
  }

  .team-card:hover {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }

  .card-content {
    padding: 1.5rem;
  }

  .admin-badge {
    background-color: #e7f1ff;
    color: #0d6efd;
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
    border-radius: 1rem;
  }

  .member-count {
    color: #6c757d;
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  .team-description {
    color: #6c757d;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .view-link {
    color: #0d6efd;
    font-weight: 500;
    text-decoration: none;
  }

  .view-link:hover {
    color: #0a58ca;
  }

  .created-date {
    color: #6c757d;
    font-size: 0.75rem;
  }
`;

const TeamCard = ({ team }) => {
  // Add comprehensive null checks
  const memberCount = team?.members?.length || 0;
  
  // Safely check if current user is admin
  const isAdmin = team?.members?.some(member => 
    member?.user?._id && 
    team?.createdBy?._id && 
    member.user._id === team.createdBy._id && 
    member.role === 'admin'
  ) || false;

  // Debug logs to help identify issues
  if (!team) {
    console.error('TeamCard received null team prop');
    return null;
  }

  return (
    <div className="team-card">
      <style>{styles}</style>
      
      <div className="card-content">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="d-flex align-items-center gap-2">
            <h5 className="mb-0">{team.name}</h5>
            {isAdmin && <span className="admin-badge">Admin</span>}
          </div>
          <div className="member-count">
            <FiUsers />
            <span>{memberCount}</span>
          </div>
        </div>

        {team.description && (
          <p className="team-description mb-3">{team.description}</p>
        )}

        <div className="d-flex justify-content-between align-items-center">
          <Link 
            to={`/team/${team?._id}`} // Add optional chaining
            className="view-link"
            onClick={(e) => {
              if (!team?._id) {
                e.preventDefault();
                console.error('Missing team ID:', team);
                console.log('teamid card:',team.id);
              }
            }}
          >
            View Details →
          </Link>
          <span className="created-date">
            Created: {new Date(team.createdAt).toLocaleDateString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TeamCard;